



import React from "react";
const CallToAction = () => {
  return (
    <>
      <div
  className="container-fluid"
  style={{
    background: "linear-gradient(45deg, var(--color-accent), var(--color-primary), #88b841)",
    padding: "var(--space-lg)",
  }}
>
  <div
    className="row mt-5 mb-5"
    style={{ paddingLeft: "var(--space-md)", paddingRight: "var(--space-md)" }}
  >
    <div
      className="col-lg-8 col-12 col-s-12"
      style={{
        fontSize: "var(--font-lg)",
        color: "var(--color-secondary)",
        fontFamily: "var(--font-secondary)",
      }}
    >
      <h1>Looking to buy in bulk?</h1>
      <b>
        Our wholesale team is available and will assist you during the process.
      </b>
    </div>
    <div className="col-lg-4 col-12 col-s-12 mt-4 d-flex justify-content-center">
      <a
        href="/Contact"
        style={{
          fontSize: "var(--font-base)",
          background: "var(--color-secondary)",
          color: "var(--color-primary)",
          padding: "15px 25px",
          borderRadius: "50px",
          textDecoration: "none",
          display: "inline-block",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        Get in touch
      </a>
    </div>
  </div>
</div>
    </>
  );
};

export default CallToAction;
